import Avatar from "@shared/v2/Avatar";
import Tooltip from "@shared/v2/Tooltip";
import type { SimplePerson } from "./types";

interface AvatarLinkProps {
  simplePerson?: SimplePerson | null;
}

const AvatarLink = ({ simplePerson = null }: AvatarLinkProps) => {
  if (simplePerson) {
    return (
      <Tooltip
        // @ts-expect-error props
        trigger={
          <a href={simplePerson.href} className="tw-flex tw-justify-center">
            {/* @ts-expect-error props */}
            <Avatar size="medium" src={simplePerson.avatar} alt={simplePerson.fullName} />
          </a>
        }
        content={simplePerson.fullName}
      />
    );
  }
  return "N/A";
};

export default AvatarLink;
